import React from 'react';

const TrainingOnly = () => {
  return (
    <p className="text-sm leading-relaxed text-justify">
      Fees once paid will not be refunded or adjusted under any circumstances.
      <br />
      By signing this document, you acknowledge that you have received and
      agreed to learn the syllabus shared by Awdiz.
    </p>
  );
};

export default TrainingOnly;
